module.exports = __webpack_public_path__ + "img/img3.8f818f53.png";